import { createRouter, createWebHashHistory } from "vue-router";
import { usePreloaderStore } from "@/store/preloader.js";
import HomeView from "@/views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/employees",
    name: "employees-list",
    component: () =>
      import(/* webpackChunkName: "list" */ "../views/employee/List.vue"),
  },
  {
    path: "/employees/create",
    name: "employees-create",
    component: () =>
        import(/* webpackChunkName: "create" */ "../views/employee/Create.vue"),
  },
  {
    path: "/employees/update/:id",
    name: "employees-update",
    component: () =>
        import(/* webpackChunkName: "update" */ "../views/employee/Update.vue"),
  },
  {
    path: "/employees/bonuses",
    name: "employees-bonuses",
    component: () =>
        import(/* webpackChunkName: "bonuses" */ "../views/employee/Bonus.vue"),
  },
  {
    path: "/employees/result",
    name: "employees-result",
    component: () =>
        import(/* webpackChunkName: "result" */ "../views/employee/Result.vue"),
  },
  {
    path: "/employees/data/delete",
    name: "employees-data-delete",
    component: () =>
        import(/* webpackChunkName: "data-delete" */ "../views/employee/DeleteData.vue"),
  },
  {
    path: "/employees/holidayToAll",
    name: "employees-holidayToAll",
    component: () =>
        import(/* webpackChunkName: "data-delete" */ "../views/employee/HolidayToAll.vue"),
  },
  {
    path: "/employees/bulkAbsent",
    name: "bulk-absent",
    component: () => import(/* webpackChunkName: "bulk-absent" */ "../views/employee/BulkAbsent.vue"),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const preloader = usePreloaderStore();
  preloader.show();
  next();
});

// Hide preloader after navigation is complete
router.afterEach(() => {
  const preloader = usePreloaderStore();
  preloader.hide();
});

export default router;
